<h1 mat-dialog-title>{{'signatureModal.signatureLabel' | translate}}</h1>
<mat-dialog-content>
	<img [src]="imageSrc">
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
		<span>{{'signatureModal.closeButton' | translate}}</span>
	</button>
</mat-dialog-actions>
